import { OnbOptionType } from '../../../../types';
import { LayoutDataType } from '../../types';

export const OPTIONS: OnbOptionType<LayoutDataType['outfits']>[] = [
  {
    id: 'hot',
    title: 'I want super hot outfits! 🔥',
  },
  {
    id: 'casual',
    title: 'I prefer casual looks 👗',
  },
  {
    id: 'unique',
    title: 'I’m looking for unique outfits 👘',
  },
  {
    id: 'nothing',
    title: 'Not my thing 🗿',
  },
];
